import { Show } from '@dvb/ui';
import clsx from 'clsx';

import './index.css';

interface Props {
  className?: string;
  type: 'error' | 'success' | 'warning';
}

/**
  @see https://codepen.io/mxmsl/pen/oQXLPm
*/
export function AnimateIcon({ className = '', type }: Props) {
  return (
    <div className={clsx('f-modal-alert', className)}>
      <Show when={type === 'success'}>
        <div className="f-modal-icon f-modal-success animate text-success">
          <span className="f-modal-line f-modal-tip animate-success-tip" />
          <span className="f-modal-line f-modal-long animate-success-long" />
          <div className="f-modal-placeholder" />
          <div className="f-modal-fix" />
        </div>
      </Show>

      <Show when={type === 'warning'}>
        <div className="f-modal-icon f-modal-warning animate text-warning">
          <span className="f-modal-body pulse-warning-ins" />
          <span className="f-modal-dot pulse-warning-ins" />
        </div>
      </Show>

      <Show when={type === 'error'}>
        <div className="f-modal-icon f-modal-error animate text-danger">
          <span className="f-modal-x-mark">
            <span className="f-modal-line f-modal-left animate-xleft" />
            <span className="f-modal-line f-modal-right animate-xright" />
          </span>
          <div className="f-modal-placeholder" />
          <div className="f-modal-fix" />
        </div>
      </Show>
    </div>
  );
}
